import { isEmpty } from "lodash";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Grid, GridRow, Popup, Table } from "semantic-ui-react";

import {
  CommonTable,
  CustomButton,
  InputText,
  InputTextArea,
  NewImageUploader,
  Switch,
  TitleView
} from "../../../../components";
import { DISABLE_IS_ROOT_PRODUCT_BUTTON, PackagingColDetails } from "../../../../config/constants";

import { InfoIcon } from "lucide-react";
import { IsRootProduct } from "../../../../config/enums/ProductType.enum";
import ProductMatching from "../../component/productMatching/ProductMatching";
import "../productDetails.scss";

const ProductDetailSummery = ({
  productDetails,
  defaultSalesUnit,
  productIsAverage,
  productIsAverageStatus
}: any) => {
  const navigate = useNavigate();
  const values = useMemo(() => {
    return {
      product_name: productDetails?.product_name,
      registration_number: productDetails?.registration_number,
      product_other_info: productDetails?.product_other_info,
      product_type: productDetails?.product_type
    };
  }, [productDetails]);

  const filterSalesUnit = useMemo(() => {
    return productDetails?.sales_units.filter((e: any) => e?._id === defaultSalesUnit) || [];
  }, [defaultSalesUnit, productDetails]);

  const {
    register,
    formState: { errors }
  } = useForm({
    mode: "all",
    defaultValues: values,
    values: values
  });

  const titleWithPopup = [
    <Grid>
      <GridRow textAlign="center" className="pl-1 pb-2">
        <span>Average Impact Product</span>
        <Popup
          content={`Generates an ''average product'' using the carbon footprint and volume of selected products`}
          trigger={<InfoIcon className="ml-1" size={20} color="green" />}
        />
      </GridRow>
    </Grid>
  ];

  //product details view table
  const loadTableData = () => {
    return filterSalesUnit?.map((data: any, index: any) => {
      return (
        <Table.Row className="tbleR" key={index}>
          <Table.Cell>
            <p>{data["sales_unit_name"]}</p>
          </Table.Cell>
          <Table.Cell>
            <p>{data["sales_unit_size"]}</p>
          </Table.Cell>
          <Table.Cell>
            <p>{data["sales_unit_type"]}</p>
          </Table.Cell>
          <Table.Cell>
            <p>{data["ean_barcode"]}</p>
          </Table.Cell>
          {!productIsAverageStatus ? (
            <Table.Cell>
              <CustomButton
                theme="green"
                title={"View Mapping"}
                onClick={() => {
                  navigate(`/mapping/product?sourceId=${data?._id}`);
                }}
                buttonOutLine={true}
              />
            </Table.Cell>
          ) : null}
        </Table.Row>
      );
    });
  };

  return (
    <>
      <form>
        <>
          <TitleView title="Product Info" />
          <Grid className="productDetailsViewMain">
            <Grid.Column computer={8} tablet={16} mobile={16} className="paddingRemoveBottom">
              <InputText
                register={register}
                errors={errors.product_name}
                labelName={"Name"}
                placeholder="Name"
                name="product_name"
                required={true}
                errorMessage={"Please enter product name"}
                disabled={true}
                customText={"removeInputBorder"}
              />
            </Grid.Column>
            <Grid.Column computer={8} tablet={16} mobile={16} className="paddingRemoveBottom">
              <InputText
                register={register}
                errors={errors.registration_number}
                labelName={"Register Number"}
                placeholder="Register Number"
                name="registration_number"
                required={false}
                disabled={true}
                customText={"removeInputBorder"}
              />
            </Grid.Column>

            <Grid.Column computer={8} tablet={16} mobile={16}>
              <InputText
                register={register}
                errors={errors.product_type}
                labelName={"Product Type"}
                placeholder="Product Type"
                name="product_type"
                required={false}
                disabled={true}
                customText={"removeInputBorder"}
              />
            </Grid.Column>
            <Grid.Column computer={8} tablet={16} mobile={16}>
              {!isEmpty(productDetails?.product_image_path) ? (
                <NewImageUploader
                  buttonTitle={"Upload an Image"}
                  defaultImage={productDetails?.product_image_path}
                  uploadButtonView={false}
                  deleteButtonView={false}
                  mainTitle={"Product Image"}
                />
              ) : null}
            </Grid.Column>
            <Grid.Column computer={8} tablet={16} mobile={16} className="paddingRemoveBottom">
              <InputTextArea
                register={register}
                errors={errors.product_other_info}
                labelName={"Additional Information"}
                placeholder="Additional Information"
                name="product_other_info"
                customInputValidation={true}
                disabled={true}
                customText={"removeInputBorder"}
              />
            </Grid.Column>
            {!DISABLE_IS_ROOT_PRODUCT_BUTTON && (
              <Grid.Column
                computer={8}
                tablet={16}
                mobile={16}
                className="paddingRemoveBottom mb-2"
              >
                <Switch
                  customTitleStatus={true}
                  customTitle={titleWithPopup}
                  onClick={(val: any) => {}}
                  titleOne={IsRootProduct.YES}
                  titleTwo={IsRootProduct.NO}
                  defaultValue={productIsAverage}
                  titleOneValue={IsRootProduct.YES}
                  titleTwoValue={IsRootProduct.NO}
                  disabled
                />
              </Grid.Column>
            )}
            {productDetails?.sales_units?.length > 0 ? (
              <Grid.Column computer={16} tablet={16} mobile={16} className="mb-2">
                <TitleView title="Sales Unit" />
                <CommonTable tableHeaderData={PackagingColDetails}>{loadTableData()}</CommonTable>
              </Grid.Column>
            ) : null}
          </Grid>
          {!DISABLE_IS_ROOT_PRODUCT_BUTTON && (
            <ProductMatching id={productDetails._id} matchingContentView={false} disableEdit />
          )}
        </>
      </form>
    </>
  );
};

export default ProductDetailSummery;
